import { getAuthHeaders } from "../../utils/authHeader";
import axiosInstance from "../../utils/axiosInstance";

const BASE_URL = `/transactions`;

export const fetchAccountBalance = async () => {
  const res = await axiosInstance.get(`${BASE_URL}/balance`, getAuthHeaders());
  return res.data;
};

export const fetchPaginatedTransactions = async (page, limit) => {
  const res = await axiosInstance.get(
    `${BASE_URL}/paginated?page=${page}&limit=${limit}`,
    getAuthHeaders(),
  );
  return res.data;
};

export const fetchAllUserCredits = async () => {
  const res = await axiosInstance.get(
    `${BASE_URL}/users-credits`,
    getAuthHeaders(),
  );
  return res.data;
};

export const createCheckoutSession = async (data) => {
  const res = await axiosInstance.post(
    `${BASE_URL}/create-checkout-session`,
    data,
    getAuthHeaders(),
  );
  return res.data;
};

export const createSubscriptionSession = async (data) => {
  const res = await axiosInstance.post(
    `${BASE_URL}/create-subscription-session`,
    data,
    getAuthHeaders(),
  );
  return res.data;
};

export const getStripeRenewal = async () => {
  const res = await axiosInstance.get(
    `${BASE_URL}/next-renewal`,
    getAuthHeaders(),
  );
  return res.data;
};

export const cancelStripeSubscription = async () => {
  const res = await axiosInstance.post(
    `${BASE_URL}/cancel-subscription`,
    {},
    getAuthHeaders(),
  );
  return res.data;
};
